/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Page2_ValvesInputs */



/**
* | output |
* | --- |
* | "Thermostatic heads requiring intervention" |
*
* @param {Intervention_Plan_Pdf_Page2_ValvesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_page2_valves = /** @type {((inputs?: Intervention_Plan_Pdf_Page2_ValvesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Page2_ValvesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Thermostatic heads requiring intervention")
	return /** @type {LocalizedString} */ ("Liste des Têtes th. nécessitant une intervention")
});